// extracted by mini-css-extract-plugin
export default {"flavors_title":"S8","no_selected_flavors":"T8","success":"U8","select_flavors_wrapper":"V8","flavors_select":"W8","custom_select_control":"X8","opened":"Y8","subtitle":"Z8","selected_flavors":"a9","selected_flavor_item":"b9","selected_flavor_item_image":"c9","selected_flavor_item_title":"e9","selected_flavor_item_qty":"f9","drawer_header":"g9"};
    if(module.hot) {
      // 1730991512890
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  